import { List as ChakraList } from '@chakra-ui/react';

type ListProps = React.ComponentProps<typeof ChakraList>;

const List = ({ children, ...props }: Readonly<ListProps>) => {
  return <ChakraList {...props}>{children}</ChakraList>;
};

export default List;
